import styled from "@emotion/styled";

export const SquareBlock = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  position: relative;
`;
